import { render, staticRenderFns } from "./PictureAndText.vue?vue&type=template&id=86221a4c"
import script from "./PictureAndText.vue?vue&type=script&lang=js"
export * from "./PictureAndText.vue?vue&type=script&lang=js"
import style0 from "./PictureAndText.vue?vue&type=style&index=0&id=86221a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports